import { render, staticRenderFns } from "./SHOffers.vue?vue&type=template&id=65d9b789"
import script from "./SHOffers.vue?vue&type=script&lang=js"
export * from "./SHOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports